import { DETERMINAR_PAGINA_ATUAL_ROTA } from '../types'

export default function determinarPaginaAtualRotas (paginaAtual) {
  return {
    type: DETERMINAR_PAGINA_ATUAL_ROTA,
    payload: paginaAtual
  }
}
